import React, { useState } from 'react'
import { ApiAutoComplete } from '../../../components/FormElements/ApiAutoComplete'
import CancelIcon from '@mui/icons-material/Cancel'
import { FormProvider, useForm } from 'react-hook-form'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'

interface WizardSelectionSearchProps {
  setValue?: (value: string | undefined) => void
  setTermName?: (value: string | undefined) => void
  setOpenModal: (open: boolean) => void
  apiEndpoint: string
  label: string
  labelField: string
  name: string
}

export const WizardSelectionSearch: React.FC<WizardSelectionSearchProps> = ({
  setValue,
  setOpenModal,
  setTermName,
  apiEndpoint,
  label,
  labelField,
  name
}): JSX.Element => {
  const methods = useForm()
  const [searchValue, setSearchValue] = useState<Record<string, any>>({})
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    const returnVal = methods.getValues(name)
    setValue?.(returnVal as string)

    if (setTermName) {
      setTermName(searchValue?.termName ?? '')
    }
    setOpenModal(false)
  }

  const handleCloseModal = (): void => {
    setValue?.(undefined)
    methods.reset()
    setOpenModal(false)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={(e) => { handleSubmit(e) }}>
        <ApiAutoComplete
          apiEndpoint={apiEndpoint}
          label={label}
          labelField={labelField}
          name={name}
          clearIcon={<CancelIcon />}
          onChange={setSearchValue}
        />
        <DefaultModalActions
          destructiveButtonProps={{ onClick: handleCloseModal }}
          confirmButtonProps={{ type: 'submit' }}
        />
      </form>
    </FormProvider>
  )
}
